import { useEffect, useState } from "react";

import { apiRoot } from "../constants";
import { useAuth } from "./useAuth";

const useNotifications = () => {
  const { token } = useAuth();

  const [notifications, setNotifications] = useState([]);
  const [error, setError] = useState(false);

  useEffect(() => {
    fetch(`${apiRoot}/notifications`, {
      headers: {
        Authorization: `Token ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((resp) => {
        if (resp.status === 200) {
          resp.json().then((json) => {
            setNotifications(json);
            setError(false);
          });
        } else {
          setError(true);
          setNotifications(null);
        }
      })
      .catch((err) => {
        setError(true);
        setNotifications(null);
      });
  }, [token]);

  return {
    notifications,
    error,
  };
};

export default useNotifications;
